<app-corporate-header></app-corporate-header>
<div class="container track-details">
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
      <div class="truck-left">
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/dashboard.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToDashboard()">Dashboard</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trip.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToBookATrips()">Book a Trip</h5>
          </div>
        </div>
        <div class="dashboard-menu active">
          <div class="truck-left-icon">
            <img src="assets/img/trp.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToTrips()">Trips</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/wo.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoTOWorkOrders()">Work Orders</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/ledg.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToLedger()">Ledger</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/help.svg" alt="" />
          </div>
          <div class="truck-left-details" (click)="help()">
            <h5>Help</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12" *ngIf="trips_track">
      <div class="trip-acoordion">
        <div class="dash-trucks-top1">
          <a
            [ngClass]="{ active: tripType == 'All' }"
            (click)="getTripsList('All')"
            >All</a
          >
          <a
            [ngClass]="{ active: tripType == 'liveTrips' }"
            (click)="getTripsList('liveTrips')"
            >Live Trips</a
          >
          <a
            [ngClass]="{ active: tripType == 'upcoming' }"
            (click)="getTripsList('upcoming')"
            >UpComing</a
          >
          <a
            [ngClass]="{ active: tripType == 'completed' }"
            (click)="getTripsList('completed')"
            >Completed</a
          >
          <a
            [ngClass]="{ active: tripType == 'cancelled' }"
            (click)="getTripsList('cancelled')"
            >Cancelled</a
          >
        </div>

        <div class="dash-trucks-top2">
          <button
            type="button"
            *ngIf="searchButton"
            class="button search-btn"
            (click)="openSearch()"
          >
            <img src="assets/img/search-white.svg" />
          </button>
          <div *ngIf="toggleSearch" class="search_toggle">
            <input
              uppercase
              class="search"
              placeholder="Trip ID"
              id="searchtripID"
              #newItem
              (keyup)="onInputChange(newItem)"
              (keyup.enter)="isInputValid && search(newItem.value)"
            />
            <button
              [disabled]="!isInputValid"
              *ngIf="search_Btn"
              class="search_number"
              (click)="search(newItem.value)"
            >
              <img src="assets/img/search-white.svg" />
            </button>
            <button
              type="button"
              class="search_number1"
              *ngIf="cancelSearchButton"
              (click)="cancelSearch()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
              >
                <path
                  d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <!-- <div [class.spinner]="tripsloading"></div> -->
      <div
        class="row to_container"
        *ngIf="
          !corporateArray?.length && !customerArray?.length && !tripsloading
        "
      >
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div *ngIf="corporateArray != 0">
        <form *ngFor="let trips of corporateArray">
          <div class="trips-page mt-3">
            <div class="row">
              <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
                <div class="trip-view-top">
                  <div class="trip-view-top-left">
                  <!-- <img src="assets/img/trip.svg" alt="" /> -->
                    <img src="assets/img/trip.svg" alt=""/>
                    <h6>{{ trips.trip_id }}</h6>
                  </div>
                  <div class="trip-view-top-right">
                    <div class="trip-top-right-top">
                      {{ trips.truck_type[0]?.truck_feet }}
                    </div>

                    <div class="trip-top-right-middle">
                      <span class="location-1">{{ trips.pickup_details.from_city_name }}</span>
                      <span class="location-img">
                        <!-- <img src="assets/img/trip-location.svg" alt=""/> -->
                        <img
                          [src]="trips.stops?.length > 0
                                  ? '../../../assets/img/trip-location-stop.svg' 
                                  : '../../../assets/img/trip-location.svg'"
                          alt=""
                        />
                      </span>
                      <span class="location-2">{{ trips.dropoff_details.to_city_name }}</span>
                    </div>
                    <div class="trip-top-right-bottom">
                      Load: {{ trips.material_type }}
                    </div>
                  </div>
                </div>
                <div class="trip-view-bottom">
                  <div
                    class="trips-amount"
                    *ngIf="
                      trips.workorderInfo[0]?.pay_as_load_quantity ==
                      'unloaded_quantity'
                    "
                  >
                    <a>Credit Trip:</a>
                    <div>
                      <p>
                        ₹
                        {{
                          trips.workorderInfo[0]?.price_per_ton *
                            trips.workOrderOtherDetails?.unloading_point || 0
                            | number : "1.2-2"
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="trips-amount"
                    *ngIf="
                      trips.workorderInfo[0]?.pay_as_load_quantity ==
                      'loaded_quantity'
                    "
                  >
                    <a>Credit Trip:</a>
                    <div>
                      <p>
                        ₹
                        {{
                          trips.workorderInfo[0]?.price_per_ton *
                            trips.workOrderOtherDetails?.loading_point || 0
                            | number : "1.2-2"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="billing-amount">
                    <a>Price Per Ton:</a>
                    <div>
                      <p>
                        ₹
                        {{ (trips.workorderInfo[0]?.price_per_ton).toFixed(2) }}
                      </p>
                    </div>
                  </div>
                  <div class="billing-amount">
                    <a>Date:</a>
                    <div>
                      <p>{{ trips.pickup_date | date : "dd-MM-yyyy" }}</p>
                    </div>
                  </div>

                  <!-- un_loading Point -->
                  <div
                    class="billing-amount"
                    *ngIf="
                      trips.workorderInfo[0]?.pay_as_load_quantity ==
                      'unloaded_quantity'
                    "
                  >
                    <a> Unloaded Quantity:</a>
                    <div>
                      <p>
                        {{
                          trips.workOrderOtherDetails?.unloading_point
                            | number : "1.2-2"
                        }}
                      </p>
                    </div>
                  </div>

                  <!-- loading Point -->

                  <div
                    class="billing-amount"
                    *ngIf="
                      trips.workorderInfo[0]?.pay_as_load_quantity ==
                      'loaded_quantity'
                    "
                  >
                    <a> Loading Quantity:</a>
                    <div>
                      <p>
                        {{
                          trips.workOrderOtherDetails?.loading_point
                            | number : "1.2-2"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 view_btn_row">
                <div class="trip-view-left">
                  <button class="trip-btn" (click)="viewTrips(trips)">
                    <img src="assets/img/eye.svg" alt="" /> View Details
                  </button>
                </div>
              </div>
            </div>
            <div
              class="row"
              *ngIf="
                trips.trip_status === 'tripstarted' ||
                trips.trip_status === 'inprogress'
              "
            >
              <!-- 
              trips.trip_status === 'inprogress' ||
              trips.trip_status === 'tripbooked' || -->
              <div class="col-12">
                <div class="track">
                  <div (click)="liveTrack(trips._id)">Track</div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <form *ngFor="let item of customerArray; let i = index">
        <div class="trips-page mt-3">
          <div class="row">
            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
              <div class="row trip-view-top">
                <div
                  class="col-xl-3 col-lg-3 col-md-12 col-sm-12 trip-view-top-left"
                >
                  <img src="assets/img/trip.svg" alt="" />
                  <h6>{{ item.trip_id }}</h6>
                </div>
                <div
                  class="col-xl-9 col-lg-9 col-md-12 col-sm-12 trip-view-top-right"
                >
                  <div class="trip-top-right-top">
                    {{ item.truck_type[0].truck_feet }} Truck
                  </div>
                  <div class="trip-top-right-middle">
                    <span class="location-1">{{
                      item.pickup_details.from_city_name
                    }}</span>
                    <span class="location-img"
                      ><img src="assets/img/trip-location.svg" alt=""
                    /></span>
                    <span class="location-2">{{
                      item.dropoff_details.to_city_name
                    }}</span>
                  </div>
                  <div class="trip-top-right-bottom">
                    Load: {{ item.material_type }}
                  </div>
                </div>
              </div>
              <div class="trip-view-bottom">
                <div class="trips-amount">
                  <a>Paid Amount:</a>
                  <div>
                    <p>
                      ₹
                      {{
                        item.payment_details[0]?.price_details?.payment_history
                          ? (
                              (item.payment_details[0]?.price_details
                                ?.amount_paid || 0) +
                              (item.payment_details[1]?.price_details
                                ?.amount_paid || 0)
                            ).toFixed(2)
                          : ""
                      }}
                    </p>
                  </div>
                </div>
                <div class="billing-amount">
                  <a>Balance Amount:</a>
                  <div>
                    <p>
                      ₹
                      {{
                        item.payment_details[0]?.price_details?.payment_history
                          ? (
                              item.payment_details[0]?.price_details
                                ?.total_amount -
                              ((item.payment_details[0]?.price_details
                                ?.amount_paid || 0) +
                                (item.payment_details[1]?.price_details
                                  ?.amount_paid || 0))
                            ).toFixed(2)
                          : ""
                      }}
                    </p>
                  </div>
                </div>
                <div class="billing-amount">
                  <a>Billing Amount:</a>
                  <div>
                    <p>
                      ₹
                      {{
                        (item.payment_details[0]?.price_details?.total_amount).toFixed(
                          2
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="billing-amount">
                  <a>Date:</a>
                  <div>
                    <p>{{ item.pickup_date | date : "dd-MM-yyyy" }}</p>
                  </div>
                </div>
                <div class="billing-amount">
                  <a>Weight:</a>
                  <div>
                    <p>{{ item.truck_type[0]?.truck_weight }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
              <div class="trip-view-left">
                <button
                  class="customer-trip-btn"
                  [ngClass]="{
                    active: viewTripIndex === item ? tripType == 'quote' : ''
                  }"
                  (click)="getTripsList('-1')"
                  (click)="GoToTripDetails(item)"
                  *ngIf="item.trip_status != 'quote'"
                >
                  <img src="assets/img/eye.svg" alt="" /> View Details
                </button>

                <button
                  class="customer-trip-btn"
                  [ngClass]="{
                    active: cancelTripIndex === i ? tripType == 'cancel' : ''
                  }"
                  (click)="getTripsList('cancel')"
                  (click)="GoToCancelTrip(i, item.trip_status)"
                  *ngIf="
                    item.trip_status != 'cancelled' &&
                    item.trip_status == 'tripbooked'
                  "
                >
                  <img src="assets/img/cross.svg" alt="" />Cancel Trip
                </button>
                <button
                  class="customer-trip-btn"
                  [ngClass]="{
                    active:
                      payNowTripIndex === i ? tripType == 'paybalance' : ''
                  }"
                  (click)="getTripsList('paybalance')"
                  (click)="payNow(i, item.payment_details[0], item)"
                  *ngIf="
                    item.payment_details[0]?.payment_status == 'not-paid' &&
                    item.payment_details[1]?.payment_status != 'fully-paid'
                  "
                >
                  <img src="assets/img/rupee-black.svg" alt="" />Pay Now
                </button>
                <!-- <button
                  class="customer-trip-btn"
                  [ngClass]="{
                    active:
                      payNowTripIndex === i ? tripType == 'paybalance' : ''
                  }"
                  (click)="getTripsList('paybalance')"
                  (click)="payBalance(i, item.payment_details[0], item)"
                  *ngIf="
                    item.payment_details[0]?.payment_status == 'partial-paid'
                  "
                >
                  <img src="assets/img/rupee-black.svg" alt="" />Pay Balance
                </button> -->

                <button
                  class="customer-trip-btn"
                  [ngClass]="{ active: tripType == 'consignment' }"
                  *ngIf="
                    item.payment_details[0]?.payment_status == 'fully-paid'
                  "
                  (click)="consignNote(item)"
                >
                  <img
                    src="assets/img/file-invoice-solid.svg"
                    alt=""
                    style="width: 14%"
                  />Consignment Cum Invoice
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="track" *ngIf="live_track">
                <div
                  *ngIf="
                    item.trip_status != 'cancelled' &&
                    item.trip_status != 'quoteBooked' &&
                    item.trip_status != 'completed'
                  "
                  (click)="liveTrack(item._id)"
                >
                  Track
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="trip-cancel-container"
          *ngIf="cancelTrip && cancelTripIndex === i"
        >
          <form>
            <div class="trip-detail-popup-right">
              <img
                src="assets/img/icons8-macos-close-60.png"
                class="close-icons"
                (click)="close()"
              />
            </div>
            <div class="trip-cancel">
              <p>Refund Summary</p>
              <mat-divider></mat-divider>
              <div class="card-details card-details-total">
                <div class="trip-details-left">Booking Amount</div>
                <div class="trip-details-right">
                  ₹
                  {{
                    this.trips[this.cancelTripIndex]?.payment_details[0]
                      .price_details.actual_price
                  }}
                </div>
                <div class="trip-details-left">Deductions</div>
                <div class="trip-details-right"></div>
                <div *ngFor="let item of taxDetails">
                  <div class="trip-details-left">{{ item.tax_name }}</div>
                  <div class="trip-details-right">₹ {{ item.tax_amount }}</div>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="card-details-container">
                <div class="refund-amount-left">Refund Amount</div>
                <div class="refund-amount-right">₹ {{ refundAmount }}</div>
                <div class="refund-cancel">
                  <div class="refund-reasons">Reasons for cancellation</div>
                  <div class="refund-reasons-radio">
                    <mat-radio-group>
                      <mat-radio-button value="1" (click)="transporter()"
                        >I have a better deal from other website or transporter
                      </mat-radio-button>
                      <mat-radio-button value="2" (click)="cancel()"
                        >My trip as been postponed or cancelled </mat-radio-button
                      ><br />
                      <mat-radio-button value="3" (click)="others()"
                        >others</mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
                <form [formGroup]="cancelReasonForm">
                  <div class="refund-cancel-right" *ngIf="otherTrips">
                    <textarea
                      name=""
                      id=""
                      rows="4"
                      formControlName="transportDetails"
                      placeholder="Enter the cancellation reason"
                    ></textarea>
                    <mat-error *ngIf="transporterTrips">
                      reason is Required</mat-error
                    >
                  </div>
                  <div class="refund-cancel-right" *ngIf="transporterTrips">
                    <textarea
                      name=""
                      id=""
                      rows="4"
                      formControlName="otherDetails"
                      placeholder="Enter the Website or Transporter name"
                    ></textarea>
                    <mat-error *ngIf="otherTrips">
                      reason is Required</mat-error
                    >
                  </div>
                </form>
              </div>
              <button
                type="button"
                class="button buttonBlue fixed-btn"
                (click)="tripCancel(item._id)"
              >
                Cancel Trip
              </button>
            </div>
          </form>
        </div>
      </form>

      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button
          class="btn"
          [disabled]="fetch_page == 1"
          (click)="pagination('-1')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="btn--icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          class="btn"
          [disabled]="fetch_page == 1"
          (click)="pagination('first')"
        >
          <img
            src="assets/img/pagination-left.svg"
            alt=""
            class="btn--icon"
          />
        </button>
        <div class="pages">
          <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
        </div>
        <button
          class="btn"
          [disabled]="last_page == fetch_page"
          (click)="pagination('last')"
        >
          <img
            src="assets/img/pagination-right.svg"
            alt=""
            class="btn--icon"
          />
        </button>
        <button
          class="btn"
          [disabled]="last_page == fetch_page"
          (click)="pagination('1')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="btn--icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap=" round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
    <!-- Loader -->

    <div class="loader-container" *ngIf="tripsloading">
      <div class="circle-dot-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>

    <!-- ---------------------- Map ------------------------- -->

    <div
      class="col-xl-9 col-lg-9 col-md-12 col-sm-12 container"
      *ngIf="corporate_map"
    >
      <div class="row">
        <div class="col-md-9"></div>
        <div class="col-md-3 align-self-end text-right">
          <button
            type="button"
            class="btn btn-danger close-tracking mb-2"
            (click)="closeTracking()"
          >
            Close Tracking
          </button>
        </div>
      </div>

      <div class="loader-container" *ngIf="isLoading">
        <div class="circle-dot-loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>

      <app-map-tracker
        [curLoc]="curLoc"
        [routeSegments]="trackArray?.routeSegments"
        (truckTrackDtlsEvent)="openModal(trackArray)"
      ></app-map-tracker>

      <div class="OTP" *ngIf="trackArray?.customerCode?.code">
        <div class="row">
          <div class="col-md-12">
            <a>OTP:</a>
            {{ trackArray?.customerCode?.code }}
          </div>
        </div>
      </div>
      
      <div class="row mt-3 mb-4 px-5" *ngIf="!showFullTracking">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-primary w-100 d-flex justify-content-center align-items-center"
            style="background-color: #0d6efd; border-radius: 8px; padding: 12px; font-weight: bold; color: white;"
            (click)="viewFullTracking()"
            [disabled]="isFullTrackingLoading"
          >
            <i class="fa fa-map-marker" style="margin-right: 8px; font-size: 1.2rem;"></i>
            {{ isFullTrackingLoading ? 'Loading Full Tracking...' : 'View Full Tracking' }}
          </button>
        </div>
      </div>
      <div class="trip_status px-5">
        <div class="row">
          <div class="col-md-6 d-flex">
            <ul class="tripDetails">
              <li><label>Trip ID:</label> {{ trackArray?.trip_id }}</li>
              <li>
                <label>Truck Number:</label>
                {{ trackArray?.truckInfo?.truck_number || data?.vehicleNumber || '--' }}
              </li>
              <li>
                <label>Location:</label>
                {{ data?.address || '--' }}
              </li>
              <li>
                <label>Last Updated Date:</label>
                {{ (data?.endTrackDateTime || data?.trackDateTime) ? ((data?.endTrackDateTime || data?.trackDateTime) | date : "dd MMMM yyyy, hh:mm:ss a") : '--' }}
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="tripDetails">
              <li>
                <label>Truck Owner Name:</label>
                {{ trackArray?.truckOwnerInfo?.username || trackArray?.truckownerDetails?.username }}
              </li>
              <li>
                <label>Truck Owner Number:</label>
                {{ trackArray?.truckOwnerInfo?.mobile || trackArray?.truckownerDetails?.mobile }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="myModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title trip">{{ trackArray?.trip_id }}</h4>
        <button
          type="button"
          (click)="closeModel()"
          class="close"
          data-dismiss="modal"
        >
          &times;
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="name">Trip Date</div>
            {{ trackArray?.trip_start | date : "dd-MM-yyyy" }}
          </div>
          <div class="col-md-6">
            <div class="name">Driver Name:</div>
            {{ trackArray?.driverInfo?.username || trackArray?.driverDetails?.username }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="name">Driver Number:</div>
            {{ trackArray?.driverInfo?.mobile || trackArray?.driverDetails?.mobile }}
          </div>
          <div class="col-md-6">
            <div class="name">Truck Number:</div>
            {{ trackArray?.truckInfo?.truck_number || data?.vehicleNumber || '--' }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="name">Lat:</div>
            {{ trackArray?.truckLocation?.[0]?.latitude || data?.latitude }}
          </div>
          <div class="col-md-6">
            <div class="name">Long:</div>
            {{ trackArray?.truckLocation?.[0]?.longitude || data?.longitude }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="name">Last Updated</div>
            {{ (data?.endTrackDateTime || data?.trackDateTime) ? ((data?.endTrackDateTime || data?.trackDateTime) | date : "dd MMMM yyyy, hh:mm:ss a") : '--' }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="name">Location</div>
            {{ data?.address || '--' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

